import React, { useContext, useState } from 'react';
import { Menu, Image, Modal, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';


import { AuthContext } from '../context/auth';

function MenuBar() {
  const { user, logout } = useContext(AuthContext);
  const pathname = window.location.pathname;

  const path = pathname === '/' ? 'home' : pathname.substr(1);
  console.log(path);
  const [activeItem, setActiveItem] = useState(path);
  
  const handleItemClick = (e, { name }) => setActiveItem(name);



  const customContent = (
    <>
    <Header>KP is your Karma Points</Header>
    <Header as="h4">Upvotes increase your Karma Points. People usually upvote your content if your events are public, or your events require no/little money. </Header>
    <Header as="h4">Downvotes decrease your Karma Points. People usually downvote if you post non-public events, or post events last second etc on purpose.</Header>
    <Header as="h4">More Karma means, you are notified first when there are cool deals, other events with free food or nice food deals.</Header>
    </>
  )
  const menuBar = user ? (
    <Menu pointing secondary color="teal">
      <Menu.Menu position="left">
        <Menu.Item > 
          <Image alt="Profile" src={user.avatar} style={{marginTop: "10px", height: "auto", maxWidth: "30px", borderRadius: "50%"}} />
        </Menu.Item>
        <Menu.Item name={"Welcome: " + user.username} as={Link} to="/" />
        <Menu.Item name="map" active={activeItem === 'map'} onClick={handleItemClick} as={Link} to="/map" />

        <Modal trigger={<Menu.Item style={{marginTop: "10px", height: "60%", maxWidth: "30px"}} name={"Karma: 3 Pts."} />}>
        <Modal.Header>What The Heck is "Karma Points"?</Modal.Header>
        <Modal.Content image>
      <Image wrapped size='medium' src='http://www.talkativeman.com/img/karma.png' />
      <Modal.Description>
       {customContent}
      </Modal.Description>
    </Modal.Content>
  </Modal>

                    
          
          
      </Menu.Menu>
        
      
      <Menu.Menu position="right">
        <Menu.Item name="logout" onClick={logout} />
      </Menu.Menu>
    </Menu>
  ) : (
    <Menu pointing secondary size="massive" color="teal">
      <Menu.Item
        name="home"
        active={activeItem === 'home'}
        onClick={handleItemClick}
        as={Link}
        to="/"
      />

      <Menu.Item
        name="map"
        active={activeItem === 'map'}
        onClick={handleItemClick}
        as={Link}
        to="/map"
      />

      <Menu.Menu position="right">
        <Menu.Item
          name="login"
          active={activeItem === 'login'}
          onClick={handleItemClick}
          as={Link}
          to="/login"
        />
        <Menu.Item
          name="register"
          active={activeItem === 'register'}
          onClick={handleItemClick}
          as={Link}
          to="/register"
        />
      </Menu.Menu>
    </Menu>
  );

  return menuBar;
}

export default MenuBar;
